import { isObject } from 'lodash';
import { launchGiosgChat, mockGiosgChat } from './launchChat';

export interface CartItem {
  name: string;
  price?: string;
  quantity?: string;
  monthly_price?: string;
}

const isGiosgLoaded = () => isObject(window._giosg);

const submitGiosgBasket = (data: CartItem[]) => {
  if (!isGiosgLoaded()) {
    return;
  }
  const formattedData = data.map((item) => {
    return {
      name: item.name,
      price: item.price ? item.price : '',
      quantity: '',
      monthly_price: item.monthly_price ? item.monthly_price : '',
    };
  });
  window._giosg(() => {
    window.giosg.api.shoppingCart.submit(formattedData);
  });
};
const removeGiosgChatEntries = () => {
  if (!isGiosgLoaded()) {
    return;
  }
  window._giosg(() => {
    window.giosg.api.shoppingCart.clearCart();
  });
};

const freezeGiosgChat = () => {
  if (!isGiosgLoaded()) {
    return;
  }
  window._giosg(() => {
    window.giosg.api.shoppingCart.freeze();
  });
};

const hideGiosgChat = () => {
  if (!isGiosgLoaded()) {
    return;
  }
  window._giosg('chat', 'hide', { preserveWindowState: true });
};

const Chat = {
  launchGiosgChat,
  mockGiosgChat,
  submitGiosgBasket,
  removeGiosgChatEntries,
  freezeGiosgChat,
  hideGiosgChat,
};

export default Chat;
